import React from 'react'
import { Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import UsageChart from '../UsageChart'

interface TimeSeriesEntry {
  date: string
  requests: number
  durationMinutes: number
  cost: number
  httpRequests: number
  websocketRequests: number
  diarizationRequests: number
  asyncRequests: number
  failedRequests: number
  avgProcessingTime: number
}

interface UsageChartsTabProps {
  timeSeriesData: TimeSeriesEntry[]
}

const UsageChartsTab: React.FC<UsageChartsTabProps> = ({ timeSeriesData }) => {
  const { t } = useTranslation()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <UsageChart
          dailyUsage={timeSeriesData}
          engineUsage={[]}
          type="requests"
          title={t('dailyRequests', 'Daily Requests')}
          height={300}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <UsageChart
          dailyUsage={timeSeriesData}
          engineUsage={[]}
          type="cost"
          title={t('dailyCost', 'Daily Cost')}
          height={300}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <UsageChart
          dailyUsage={timeSeriesData}
          engineUsage={[]}
          type="time"
          title={t('processingTime', 'Processing Time')}
          height={300}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <UsageChart
          dailyUsage={timeSeriesData}
          engineUsage={[]}
          type="features"
          title={t('featureUsage', 'Feature Usage')}
          height={300}
        />
      </Grid>
    </Grid>
  )
}

export default UsageChartsTab
